import './style.less';

export default function($log, AuthClass, $state, HelperClass) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  vm.year = new Date().getFullYear();
  vm.prolaeraLogo = '//d4znxc3tx8unj.cloudfront.net/prolaera-white.png';
  vm.formData = {};

  vm.AuthClass = AuthClass;

  function errorMessage(message) {
    vm.error = message;
    $log.error(message);
    throw new Error(message);
  }

  vm.changePassword = function() {
    vm.error = false;

    if (!vm.formData.email || !HelperClass.validateEmail(vm.formData.email))
      return errorMessage('Invalid email address.');

    AuthClass.changePassword(vm.formData.email, function(err) {
      if (err) throw err;
      $state.go('login');
    });
  };

  function activate() {
    $log.debug('User Forgot Password Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/forgotPassword/index.js